<template>
  <span>
    <aha-antd-button
      :size="size"
      name="report-page-export-button"
      v-aha-emit-action
      class="w-full"
      variant="secondary"
      @click="openModalDownload"
    >
      <div class="flex justify-center items-center gap-2">
        <aha-icon
          class="icon"
          name="export-2"
          viewBox="0 0 18 20"
          height="18"
        />
        <span>{{ $i18nPresenter.t('Export') }}</span>
      </div>
    </aha-antd-button>
    <EditorDownloadReportModal
      v-if="showModalDownload"
      name="report-page-export-modal"
      v-aha-emit-action.view
      @hide="showModalDownload = false"
    >
      <template #item-section>
        <div class="p-5 pb-0 pt-0">
          <div class="mt-4">
            <DownloadReportSection
              :customExportUrl="customExcelExportUrl"
              :sharedToken="sharedToken"
            />
          </div>
        </div>
      </template>
      <template #below-section>
        <DownloadSlideSection
          :presentation="presentation"
          :customExportUrl="customPdfExportUrl"
          :sharedToken="sharedToken"
        />
      </template>
      <template #info-box-section>
        <AhaInfoBox v-if="isLoadingExport" class="mt-3">
          <div>{{ $i18nPresenter.t('The export is being processed in the background.') }}</div>
          <div>{{ $i18nPresenter.t('Feel free to close this modal.') }}</div>
        </AhaInfoBox>
        <span v-else></span>
      </template>
    </EditorDownloadReportModal>
  </span>
</template>

<script>
import EditorDownloadReportModal from '@/components-v2/presentation-editor/editor-header/EditorDownloadReportModal.vue'
import DownloadReportSection from '@/components-v2/editor-share-v2/DownloadReportSection.vue'
import DownloadSlideSection from '@/components-v2/editor-share-v2/DownloadSlideSection.vue'
import ExportSection from '@/components-v2/presentation-report/ExportSection.vue'

export default {
  components: {
    EditorDownloadReportModal,
    DownloadReportSection,
    DownloadSlideSection,
  },
  extends: ExportSection,
  props: {
    size: {
      type: String,
      default: 'md',
    },
    customExcelExportUrl: {
      type: String,
      default: '',
    },
    customPdfExportUrl: {
      type: String,
      default: '',
    },
    sharedToken: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      skipParentMounted: true,
      skipParentDestroyed: true,
      showModalDownload: false,
    }
  },
  methods: {
    openModalDownload() {
      this.showModalDownload = true
      this.$emit('hideModal')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
